import type { BuildifyExtension } from '@adornis/buildify/client/globals/types.js';
import '@adornis/digitale-helden-shared/client/components/component-icon-button.js';
import '@adornis/digitale-helden-shared/client/theme/d-checkbox';
import '@adornis/digitale-helden-shared/client/theme/d-input';
import { DigitaleHeldenFont } from '@adornis/digitale-helden-shared/client/theme/fonts';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { BaseMarketingFooterLink } from '../../db/links/BaseMarketingFooterLink';
import { MarketingLink, MarketingLinkExtension } from './MarketingLinkExtension';

export const MarketingFooterLinkExtension: BuildifyExtension<BaseMarketingFooterLink> = {
  ...MarketingLinkExtension,
  class: BaseMarketingFooterLink,
  render(instance, { isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <marketing-footer-link
        .content=${instance}
        .defaultValues=${this.defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></marketing-footer-link>
    `;
  },
};

@customElement('marketing-footer-link')
export class MarketingFooterLink extends MarketingLink {
  protected override _linkStyling(isActiveLink: boolean) {
    return {
      fontFamily: DigitaleHeldenFont.REGULAR,
      color: this.colors.tone.secondaryText,
      '&:hover': {
        textDecoration: 'underline',
      },
    };
  }
}
